export const A_STATIC_BG = 'assets/img/static_bg.png';
export const A_STATIC_BG_CARD = 'assets/img/static_bg_card.svg';
export const A_PAYWALL_BG = 'https://filmboxassets.tv2zcdn.com/images/welcome_page_assets/PaywallBG-INT.jpg';
export const A_PAYWALL_BG_OVERLAY = 'assets/img/paywall_bg_overlay.svg';